import * as React from "react";
import './App.css';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Painel from "./pages/painel/Painel";
import LoginPage from "./pages/login/Login";
import PrivateRoute from "./components/Router/PrivateRoute";

class App extends React.PureComponent<Props> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="App">
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/" component={LoginPage} />
                        <Route path="/nova-sessao" component={LoginPage} />
                        <Route exact path="/login" component={LoginPage} />
                        <PrivateRoute path="/painel" component={Painel} />
                    </Switch>
                </BrowserRouter>
            </div>
        );
    }

}

export default App;
